import { ObjectValues } from "helpers/types";

export const ONE_PAGE_STYLE_OPTIONS = {
  FIRST_STYLE: 'first-style',
  SECOND_STYLE: 'second-style',
  THIRD_STYLE: 'third-style',
} as const;

export type IOnePageStyles = ObjectValues<typeof ONE_PAGE_STYLE_OPTIONS>

export const ONE_PAGE_DISPLAY_MODE = {
  EXAMPLE: 'example',
  PROJECT: 'project',
} as const;

export type IOnePageDisplayMode = ObjectValues<typeof ONE_PAGE_DISPLAY_MODE>